<template>
  <div>
    <el-form :inline="true" style="margin: 0px; height: auto; vertical-align: middle">
      <el-form-item label="经理部" style="margin: 10px">
        <el-select v-model="base.sectorId" placeholder="请选择经理部" style="width: 120px">
          <el-option label="全部" :value="null" />
          <el-option v-for="item in sectorList" :key="item.sectorId" :label="item.sectorName" :value="item.sectorId" />
        </el-select>
      </el-form-item>
      <el-form-item label="省" style="margin: 10px">
        <el-select v-model="base.provinceId" placeholder="请选择省" style="width: 150px" @change="changeProvince">
          <el-option label="全部" :value="null" />
          <el-option v-for="item in provinceList" :key="item.provinceId" :label="item.provinceName" :value="item.provinceCode" />
        </el-select>
      </el-form-item>
      <el-form-item label="城市" style="margin: 10px">
        <el-select v-model="base.cityId" placeholder="城市" style="width: 150px">
          <el-option v-for="item in cityList" :key="item.cityId" :label="item.cityName" :value="item.cityCode" />
        </el-select>
      </el-form-item>
      <el-form-item label="经销商名称" style="margin: 10px">
        <el-input v-model="base.dealerName" style="width: 200px" placeholder="请填写经销商名称" />
      </el-form-item>
      <slot name="ButtonTwo"></slot>
    </el-form>
  </div>
</template>
<script>
import { findProvince, findCity, findSectorList } from '@/api/base-data.js';
export default {
  name: 'SiftDealer',
  props: ['base'],
  data() {
    return {
      sectorList: [],
      provinceList: [],
      cityList: []
    };
  },
  created() {
    this.getSectorList()
    this.findProvince() // 获取省
    // console.log(this.base);
    this.base.sectorId = null
    this.base.provinceId = null
    this.base.cityId = null
    this.base.dealerName = null
  },
  methods: {
    // 获取省份
    findProvince() {
      findProvince().then(res => {
        if (res.code === 1 && res.data) {
          this.provinceList = res.data
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 获取大区
    getSectorList() {
      findSectorList().then(res => {
        if (res.code === 1 && res.data) {
          this.sectorList = res.data
        }
      })
    },
    changeProvince() {
      if (this.base.provinceId) {
        this.findCity(this.base.provinceId)
      } else {
        this.base.cityId = null
        this.cityList = []
      }
    },
    // 获取市区
    findCity(id) {
      this.base.cityId = null
      findCity({ provinceId: id }).then(res => {
        if (res.code === 1 && res.data) {
          this.cityList = res.data
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>
<style lang="scss">
</style>
